import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import Budget from "@components/modules/projects/budget";
import { NavigationProject } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Project budget`}
    navigation={<NavigationProject id={id} />}
  >
    <Budget id={id} />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/projects/budget")({
  component: RouteComponent,
});
